import * as React from 'react';
import styles from './TextField.styl';
import classnames from 'classnames';
const TextField = (props) => {
    const onChange = (event) => {
        const value = event.currentTarget.value;
        const name = event.currentTarget.name;
        props.onChange(value, name, event);
    };
    const onKeyPress = (event) => {
        if (props.onKeyPress) {
            props.onKeyPress(event);
        }
    };
    return (React.createElement("div", { className: classnames(props.className, styles.textField, { [styles.disabled]: props.disabled }) },
        React.createElement("input", { autoComplete: props.autoComplete, min: props.min, step: props.step, max: props.max, className: classnames(styles.input, props.inputClassName, { [styles.error]: props.error }), type: props.type, value: props.value, name: props.name, disabled: props.disabled, placeholder: props.placeholder, id: props.id, onFocus: props.onFocus, onBlur: props.onBlur, onChange: onChange, onKeyPress: onKeyPress })));
};
TextField.defaultProps = {
    className: '',
    value: '',
    type: 'text',
    error: false,
    disabled: false,
    onChange: () => { },
    onKeyPress: () => { },
    onFocus: () => { },
    onBlur: () => { }
};
export default TextField;
